import { updateSettingsScheduleApi as generatedUpdateSettingsScheduleApi } from '../generated/settingsSchedule/updateSettingsSchedule';

const updateScheduleApi = generatedUpdateSettingsScheduleApi.enhanceEndpoints({
  endpoints: {
    updateSettingsSchedule: {
      invalidatesTags: ['SettingsSchedule', 'Schedule', 'Slots', 'ScheduleAroundToday', 'WeeklyScheduleTemplate'],
    },
  },
});

export const { useUpdateSettingsScheduleMutation } = updateScheduleApi;
